angular
	.module('App.Repository')
	.factory 'CurrencyConversionRatesRepository', ['BaseRepository', (BaseRepository) ->
		class CurrencyConversionRatesRepository extends BaseRepository
			@resource = '/currency_conversion_rates'
			@isRestricted = true

		return new CurrencyConversionRatesRepository
	]
